export default class OverlayCookie {
  constructor() {
    this.init();
  }

  init() {
    window.addEventListener('oneTrustCategoriesInit', () => {
      this.constructor.removeYoutubeCookieOverlay();

      window.OneTrust.OnConsentChanged(() => this.constructor.removeYoutubeCookieOverlay());
    });
  }

  static removeYoutubeCookieOverlay() {
    const ytGroup = window.YTcategories;
    const youtubeVideos = Array.from(document.getElementsByClassName('js-overlay-cookie'));
    if (ytGroup && ytGroup.length) {
      const activeGroups = window.OnetrustActiveGroups.split(',');
      const isYTAccepted = activeGroups.some(
        (value) => ytGroup.includes(value),
      );

      if (isYTAccepted) {
        youtubeVideos.forEach((video) => video.classList.add('hidden'));
      } else {
        youtubeVideos.forEach((video) => video.classList.remove('hidden'));
      }
    }
  }
}
